import styles from '@/styles/About.module.css'
import Head from 'next/head'
import BurgareHam from '@/components/BurgareHam'
import Image from 'next/image'
import HomeImage from '/public/img/Home.webp'
import { useTranslation } from 'react-i18next'

const Page = () => {
  const { t } = useTranslation()
  const generateMissingImage = (width, height, alt) => {
    if (
      !width ||
      !height ||
      typeof width !== 'number' ||
      typeof height !== 'number'
    ) {
      return (
        <Image
          src={HomeImage}
          className={styles.imageUrl}
          width={200}
          height={100}
          alt={alt || 'Image Not Available'}
          loading='lazy'
        />
      ) // or some default image URL
    }
    return (
      <Image
        src={`https://via.placeholder.com/${width}x${height}`}
        width={width}
        height={height}
        alt={alt || 'Image Not Available'}
        loading='lazy'
      />
    )
  }
  const itemList = [
    {
      name: 'Hamburgare 90g',
      description: t('A classic hamburger weighing 90g.'),
      image: '/hamburgare.webp',
      recipeIngredient: ['Hamburger', 'Weight: 90g'],
    },
    {
      name: 'Hamburgare 150g',
      description: t('A hearty hamburger weighing 150g.'),
      image: '/hamburgare.webp',
      recipeIngredient: ['Hamburger', 'Weight: 150g'],
    },
    {
      name: 'Hamburgare 200g',
      description: t('A substantial hamburger weighing 200g.'),
      image: '/hamburgare.webp',
      recipeIngredient: ['Hamburger', 'Weight: 200g'],
    },
    {
      name: 'Chicken Burger',
      description: t('A juicy chicken burger weighing 140g.'),
      image: '/chicken-burger.webp',
      recipeIngredient: ['Chicken Burger', 'Weight: 140g'],
    },
  ]

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Hamburgare Meny</title>
        <meta
          name='description'
          content='Experience a flavor explosion with our creamy and juicy burger, made with the best ingredients. Every bite is a delight for all your taste buds.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemList.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                  '@type': 'Recipe',
                  name: item.name,
                  image: item.image,
                  description: item.description,
                  recipeIngredient: item.recipeIngredient,
                },
              })),
            }),
          }}
        />
      </Head>
      <BurgareHam />
    </main>
  )
}

export default Page
